import React from 'react';

import { isEqual } from 'lodash';

import { siteIds } from '../../../constants';
import { siteId, brandSite } from '../../../sites';

import ViinimaaLink from './viinimaa';

function Link(props) {
  if (isEqual(siteId, siteIds.Viinimaa)) {
    return <ViinimaaLink {...props} />;
  }
  if (isEqual(siteId, siteIds.Folkofolk)) {
    return <ViinimaaLink {...props} />;
  }
  if (brandSite) {
    return <ViinimaaLink {...props} />;
  }

  return null;
}

export default Link;
